import { addDays, differenceInDays, format, subYears } from 'date-fns';
var generateMockBreaksData = function () {
    var endDate = new Date();
    var startDate = subYears(endDate, 1);
    var totalDays = differenceInDays(endDate, startDate) + 1;
    var breakPatterns = [
        { weight: 30, breaks: [0, 1] },
        { weight: 35, breaks: [2, 3, 4] },
        { weight: 25, breaks: [5, 6, 7] },
        { weight: 10, breaks: [8, 9, 10] }
    ];
    var getRandomBreaks = function () {
        var random = Math.random() * 100;
        var cumulativeWeight = 0;
        for (var _i = 0, breakPatterns_1 = breakPatterns; _i < breakPatterns_1.length; _i++) {
            var pattern = breakPatterns_1[_i];
            cumulativeWeight += pattern.weight;
            if (random <= cumulativeWeight) {
                return pattern.breaks[Math.floor(Math.random() * pattern.breaks.length)];
            }
        }
        return 3;
    };
    return Array.from({ length: totalDays }, function (_, i) {
        var currentDate = addDays(startDate, i);
        var dayOfWeek = currentDate.getDay();
        var isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
        var shouldSkip = isWeekend && Math.random() > 0.3;
        if (shouldSkip) {
            return null;
        }
        return {
            date: format(currentDate, 'yyyy-MM-dd'),
            count: getRandomBreaks()
        };
    }).filter(function (day) { return day !== null; });
};
export var breaksDuringWorkIndicator = function (input) {
    return generateMockBreaksData();
};
